import cn from 'classnames';

import stylesDesktop from './one-field-fio-desktop.css';

export const fioWrapperClassNameHelperDesktop = () =>
    cn(stylesDesktop.wrapperFio, stylesDesktop.field);
